export const COUNT_TYPES = {
    TOTAL: 'total',
    BILLABLE: 'billable',
    NON_BILLABLE: 'nonBillable',
    BILLABLE_ADMIN: 'billableAdmin',
    NON_BILLABLE_ADMIN: 'nonBillableAdmin',
    ABSENT: 'absent',
    UNACCOUNTED: 'unaccounted',
    TRUEABSENT: 'trueAbsent'
};
